import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { ManifestDoc, ManifestGroup, ManifestTab } from '../config/manifest';

interface Props {
  group: ManifestGroup;
  doc: ManifestDoc;
  tab?: ManifestTab;
}

export default function DocBreadcrumb({ group, doc, tab }: Props) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <Link to="/" className="breadcrumb__link">Home</Link>
      <ChevronRight className="breadcrumb__sep" aria-hidden="true" />
      <span className="breadcrumb__group">{group.title}</span>
      <ChevronRight className="breadcrumb__sep" aria-hidden="true" />
      <span className={tab ? 'breadcrumb__doc' : 'breadcrumb__leaf'}>{doc.title}</span>
      {tab && (
        <>
          <ChevronRight className="breadcrumb__sep" aria-hidden="true" />
          <span className="breadcrumb__leaf">{tab.label}</span>
        </>
      )}
    </nav>
  );
}
